export const SOFTLINE_MODULE_ENERGIETRANSPORT = 'energietransport';

export const SOFTLINE_FEATURE_TRANSPORTAUFTRAG = 'energietransport/auftrag';
export const SOFTLINE_FEATURE_TRANSPORTAUFTRAG_STATIONEN = 'energietransport/stationen';
export const SOFTLINE_FEATURE_TRANSPORTAUFTRAG_ZUSATZARTIKEL =
  'energietransport/zusatzartikel';
